import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import {
  PRICE_TYPE_OPTIONS,
  PriceType,
} from '@/pages/instruments/new-instrument/constants/price-types'

export interface PriceTypeFieldProps {}

export const PriceTypeField: React.FC<PriceTypeFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ price_type: PriceType }>()

  return (
    <FormField
      name="price_type"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center justify-between gap-2">
              <FormLabel>Price Type</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              value={value}
              setValue={(value) =>
                setValue('price_type', value as PriceType, {
                  shouldValidate: true,
                })
              }
              placeholder={'Select a price type...'}
              options={PRICE_TYPE_OPTIONS}
            />
          </FormItem>
        )
      }}
    />
  )
}
